export const amountsApproximatelyEqual = (
  a: number,
  b: number,
  decimals = 2,
): boolean => {
  if (!Number.isFinite(a) || !Number.isFinite(b)) return false;
  const factor = 10 ** decimals;
  return Math.round(a * factor) === Math.round(b * factor);
};

export const replaceCommas = (v: string): string => v.replace(/,/gi, '');

// "It will be $1000000 dollars." => "It will be $1,000,000 dollars."
export const numberWithCommas = (
  numOrString: number | string | undefined,
): string =>
  numOrString
    ? numOrString.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
    : numOrString?.toString() || '';

export const findVariance = (
  initial: number | string = 0,
  final: number | string = 0,
): number | undefined => {
  if (!initial || !final) return undefined;
  // Normalize inputs: allow comma-formatted strings like "9,876"
  const i =
    typeof initial === 'string' ? Number(replaceCommas(initial)) : initial;
  const f = typeof final === 'string' ? Number(replaceCommas(final)) : final;

  if (!Number.isFinite(i) || !Number.isFinite(f)) return undefined;
  if (i === 0) {
    return f > 0 ? 100 : 0;
  }
  if (f === 0) {
    return 0;
  }
  return Math.round(((f - i) / i) * 100);
};
